module.exports = __webpack_public_path__ + "static/social-2b-c5ac5412fabd1755745608d2886de7e1.svg";